import {
  Identifiable,
  Project,
  ProjectResource,
  resource,
  Resource,
  Role,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { LinkedResource, Linker } from "../linkers/types";

function saveResourcesInProject(httpClient: HttpClient, linker: Linker) {
  return (
    resources: Identifiable<Resource>[],
    project: Identifiable<Project>,
    role: Identifiable<Role>,
  ) =>
    httpClient
      .sendHttpRequest<
        {
          uuid: string;
          roleUuid: string;
          resourceUuid: string;
          projectUuid: string;
        }[]
      >({
        endpoint: "/projectMembers/batch",
        method: HttpMethods.POST,
        data: resources.map((resource) => ({
          resourceUuid: resource.uuid,
          projectUuid: project.uuid,
          roleUuid: role.uuid,
        })),
      })
      .then((res) =>
        resources.reduce<Identifiable<ProjectResource>[]>(
          (projectMembers, resource) => {
            const projectMember = res.find(
              ({ resourceUuid }) => resourceUuid === resource.uuid,
            );

            return projectMember
              ? [
                  ...projectMembers,
                  {
                    deactivated: false,
                    project,
                    role,
                    resource,
                    uuid: projectMember.uuid,
                  },
                ]
              : projectMembers;
          },
          [],
        ),
      );
}

export { saveResourcesInProject };
